var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinGateawayOffStateUnChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 5.8203 5.8203 0 13 0V0C20.1797 0 26 5.8203 26 13V13C26 20.1797 20.1797 26 13 26V26C5.8203 26 0 20.1797 0 13V13Z",
    fill: "#979797",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 4.33276C9.51561 4.33276 6.69727 7.04543 6.69727 10.3994C6.69727 14.9494 13.0003 21.6661 13.0003 21.6661C13.0003 21.6661 19.3033 14.9494 19.3033 10.3994C19.3033 7.04543 16.4849 4.33276 13.0003 4.33276Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6768 22.9079L13.0001 21.666L14.3235 22.9079L13.0001 24.3181L11.6768 22.9079ZM14.1995 20.289C16.028 18.0848 19.3032 13.6791 19.3032 10.3993C19.3032 7.04531 16.4848 4.33264 13.0001 4.33264C9.51548 4.33264 6.69714 7.04531 6.69714 10.3993C6.69714 13.6791 9.97226 18.0848 11.8008 20.289C12.509 21.1426 13.0001 21.666 13.0001 21.666C11.6768 22.9079 11.6768 22.9079 11.6768 22.9079L11.674 22.9049L11.6689 22.8994L11.652 22.8813L11.5922 22.8165C11.5413 22.761 11.4685 22.681 11.3771 22.5789C11.1943 22.3746 10.9362 22.0809 10.6279 21.7153C10.0129 20.986 9.18968 19.9605 8.36257 18.7806C7.53924 17.6061 6.68802 16.2445 6.03666 14.8451C5.39704 13.4709 4.88232 11.9182 4.88232 10.3993C4.88232 5.97827 8.57918 2.51782 13.0001 2.51782C17.4211 2.51782 21.118 5.97827 21.118 10.3993C21.118 11.9182 20.6032 13.4709 19.9636 14.8451C19.3123 16.2445 18.461 17.6061 17.6377 18.7806C16.8106 19.9605 15.9874 20.986 15.3724 21.7153C15.0641 22.0809 14.806 22.3746 14.6232 22.5789C14.5318 22.681 14.459 22.761 14.408 22.8165L14.3483 22.8813L14.3314 22.8994L14.3263 22.9049L14.3246 22.9067C14.3246 22.9067 14.3235 22.9079 13.0001 21.666C13.0001 21.666 13.4913 21.1426 14.1995 20.289Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7928_29915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0017 8.40902C11.6789 8.40902 10.609 9.47891 10.609 10.8017H11.2926C11.2926 9.85832 12.0583 9.09265 13.0017 9.09265C13.9451 9.09265 14.7108 9.85832 14.7108 10.8017H15.3944C15.3944 9.47891 14.3245 8.40902 13.0017 8.40902ZM13.0017 7.04175C10.9269 7.04175 9.2417 8.72691 9.2417 10.8017H9.92533C9.92533 9.10291 11.3029 7.72538 13.0017 7.72538C14.7005 7.72538 16.078 9.10291 16.078 10.8017H16.7617C16.7617 8.72691 15.0765 7.04175 13.0017 7.04175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8562 10.8017C13.8562 11.1538 13.6443 11.4512 13.3435 11.5845V12.0289H12.6599V11.5845C12.3591 11.4512 12.1471 11.1504 12.1471 10.8017C12.1471 10.33 12.53 9.9472 13.0017 9.9472C13.4734 9.9472 13.8562 10.33 13.8562 10.8017Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5194 11.967H14.8656H11.1391H10.4854V12.6862V16.2819V17.0011H11.1391H14.8656H15.5194V16.2819V12.6862V11.967Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4007 13.0857H14.0375H11.9672H11.604V13.4852V15.4829V15.8824H11.9672H14.0375H14.4007V15.4829V13.4852V13.0857Z",
    fill: "#979797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 4.99992C17.3335 2.97606 18.9763 1.33325 21.0002 1.33325C23.024 1.33325 24.6668 2.97606 24.6668 4.99992C24.6668 7.02378 23.024 8.66658 21.0002 8.66658C18.9763 8.66658 17.3335 7.02378 17.3335 4.99992Z",
    fill: "white",
    stroke: "#354052"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7928_29915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.20362,
    height: 8.20362,
    fill: "white",
    transform: "translate(8.8999 6.69995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGateawayOffStateUnChecked);
export default __webpack_public_path__ + "static/media/Pin-Gateaway-Off-State-UnChecked.408fe6f2f0ce9fde7c3e9d7dd49dc69e.svg";
export { ForwardRef as ReactComponent };